import PropTypes from 'prop-types';
import React from 'react';
import RosettaFormattedMessage, { decorateIntlMessages } from '../rosetta_formatted_message';
import SocialIcon from '../social_icon';
import {get} from 'lodash';
import { injectIntl, defineMessages } from 'react-intl';

const i18nMessages = decorateIntlMessages(__filename, defineMessages({
  share_button_title: {
    id: 'share_button_title',
    description: 'Share button title attribute content (Share on Twitter)',
    defaultMessage: 'Share on Twitter'
  }
}));

export function TwitterSocialIcon(props, context) {
  const { sanitizedTitle, url_full, enableAdTextForShares, intl, parentClass } = props;
  const twitter_handle = get(context, 'edition_data.config.twitter_handle', 'refinery29');
  const encodedURL = encodeURIComponent(url_full + '?utm_source=twitter&utm_medium=twitter_share');
  const encodedTitle = encodeURIComponent(sanitizedTitle);

  return (
    <RosettaFormattedMessage parentFilename={__filename}
      id="ad_hashtag"
      description='Translation for "#ad" in social share URLs for sponsored stories'
      defaultMessage="#ad"
    >
      {
        (ad_hashtag) => {
          const via = enableAdTextForShares
            ? encodeURIComponent(`${twitter_handle} ${ad_hashtag}`)
            : encodeURIComponent(twitter_handle);

          return (
            <SocialIcon
              url_full={url_full}
              category="Twitter"
              action="Tweet"
              socialURL={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedURL}&via=${via}`}
              faClassName="twitter"
              title={intl.formatMessage(i18nMessages.share_button_title)}
              parentClass={parentClass}
            />
          );
        }
      }
    </RosettaFormattedMessage>
  );
}
export default injectIntl(TwitterSocialIcon);

TwitterSocialIcon.propTypes = {
  sanitizedTitle: PropTypes.string.isRequired,
  url_full: PropTypes.string.isRequired,
  enableAdTextForShares: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
  parentClass: PropTypes.string
};

TwitterSocialIcon.defaultProps = {
  sanitizedTitle: '',
  url_full: '',
  enableAdTextForShares: false
};

TwitterSocialIcon.contextTypes = {
  edition_data: PropTypes.shape({
    config: PropTypes.shape({
      twitter_handle: PropTypes.string
    })
  })
};
